import React from 'react';
import { Row, Col, Tab, Tabs, TabPane, Button, Spinner } from 'react-bootstrap';
import { connect } from 'react-redux';
import './styles.scss';
import ShowTestType from '../Quiz/TestType/ShowTestType';
import { SubTitleH2 } from '../Text';
import { ArrowLeftIndex, LoadSpinner } from '../Utils';
import SwitchButton from '../Switch';
import { toggleQuizLock, downloadResults } from '../../actions/test';

const axes = axesAttributes =>
  axesAttributes.map((axe, axeIndex) => (
    <Tab
      eventKey={axeIndex}
      key={axe.id}
      title={<p className="text-dark mb-0"> {axe.name}</p>}
    >
      <TabPane>
        {axe.sub_axes_attributes.map(subAxe => {
          // let itemNumber = 0;
          return (
            <div>
              <p className="font-weight-bold mt-3 mb-1">{subAxe.name}</p>
              {subAxe.indicators_attributes.map(indicator =>
                indicator.questions_attributes.map(question => {
                  // itemNumber += 1;
                  return (
                    <div className="box-line">
                      <Row>
                        <Col md={6}>
                          <p className="mb-0">
                            {/* {itemNumber}. */}
                            Item {question.position}
                          </p>
                        </Col>
                        <Col md={3}>
                          <p className="text-center mb-0">
                            {question.question_type_id === 1
                              ? `${question.question_type.name} ${question.answer_as_letter}`
                              : `${question.question_type.name}`}
                          </p>
                        </Col>
                        <Col md={3}>
                          <p className="text-center mb-0">
                            {question.question_type_id === 3 ||
                            question.question_type_id === 4
                              ? question.question_performances_attributes.map(
                                  (performance, performIndex) =>
                                    performIndex + 1 ===
                                    question.question_performances_attributes
                                      .length
                                      ? `${performance.score} `
                                      : `${performance.score} / `
                                )
                              : `${question.score} `}
                            ptos
                          </p>
                        </Col>
                      </Row>
                    </div>
                  );
                })
              )}
            </div>
          );
        })}
      </TabPane>
    </Tab>
  ));

const ShowFinish = ({
  quiz,
  ongoingRequest,
  downloadResultsLoading,
  dispatch
}) => {
  const handleLockToggle = checked => {
    dispatch(toggleQuizLock(quiz.id, checked));
  };

  const handleDownloadResults = () => {
    dispatch(downloadResults(quiz.id));
  };

  return (
    <div>
      {ongoingRequest.getQuiz && <LoadSpinner />}
      <div>
        <ArrowLeftIndex className="mb-5 text-light" path="/tests" />
        <div className="d-flex align-items-center">
          <SubTitleH2 text="Detalles de Evaluación" />
          <div className="ml-auto d-flex align-items-center mb-3">
            <Button
              type="button"
              className={`button-with-loader ${downloadResultsLoading &&
                'loading'} justify-content-center align-items-center mr-3`}
              disabled={downloadResultsLoading}
              onClick={handleDownloadResults}
            >
              <span className="text">Descargar resultados</span>
              <Spinner
                className="spinner ml-auto mr-auto"
                animation="border"
                variant="danger"
                size="sm"
              />
            </Button>
            <span className="mr-2">Bloqueado</span>
            <SwitchButton
              checked={quiz.is_locked || false}
              handleChange={handleLockToggle}
            />
          </div>
        </div>
      </div>
      <Row>
        <Col md={5}>
          <ShowTestType quiz={quiz} />
        </Col>
        <Col md={{ span: 3, offset: 2 }}>
          <p className="mb-0 ml-6">Puntaje Total Prueba:</p>
          <p className="mb-2 ml-6">Porcentaje para logrado:</p>
          <p className="mb-0 ml-6 font-weight-bold">Porcentajes Desempeño:</p>
          {quiz.guideline.guideline_performances.map(perform => (
            <p className="mb-0 ml-3 gray-400">{`- ${perform.tag}`}</p>
          ))}
        </Col>
        <Col md={2}>
          <p className="mb-0 text-left">{quiz.total_score} ptos</p>
          <p className="mb-0 text-left">{quiz.guideline.minimum}%</p>
          <p className="mb-4 text-left" />
          <p className="mb-0 text-left"> </p>
          {quiz.guideline.guideline_performances.map(perform => (
            <div>
              <p className="mb-0 text-left">
                {`${perform.minimum}%`} / {`${perform.maximum}%`}
              </p>
            </div>
          ))}
        </Col>
      </Row>
      <Tabs defaultActiveKey="0" variant="tabs" className="tabs-axis text">
        {axes(quiz.axes_attributes)}
      </Tabs>
    </div>
  );
};

const mapStateToProps = state => {
  const {
    ongoingRequest,
    quiz: { quiz }
  } = state.test;
  return {
    ongoingRequest,
    quiz,
    downloadResultsLoading: ongoingRequest.downloadResults || false
  };
};

export default connect(mapStateToProps)(ShowFinish);
